import script from "./ForgotPasswordView.vue?vue&type=script&setup=true&lang=js"
export * from "./ForgotPasswordView.vue?vue&type=script&setup=true&lang=js"

import "./ForgotPasswordView.vue?vue&type=style&index=0&id=1feb9bc2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1feb9bc2"]])

export default __exports__